import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

const DEPARTMENTS_MOCK = {
    token: 'jnUoKtxAm/xT4z4gFJkUPTpNFIkTXQT34+KfZ2XxnJvhoBOqNy3+X51AxUVZG4UVK1im0piZPzON3MdBgJy+zw==',
    status_code: 0,
    description: 'Busca encontrada com sucesso!',
    registers: [
        {
            id_notificacao: '950',
            nome_completo: 'Confederação Brasileira de Tênis',
        },
        {
            id_notificacao: '1123',
            nome_completo: 'Departamento Técnico',
        },
        {
            id_notificacao: '1125',
            nome_completo: 'Beach Tennis',
        },
        {
            id_notificacao: '1126',
            nome_completo: 'Capacitação',
        },
        {
            id_notificacao: '1127',
            nome_completo: 'Financeiro',
        },
    ],
};

@Injectable({
    providedIn: 'root',
})
export class ContactService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    getDepartments() {
        let body = this.setBody();

        // return of(DEPARTMENTS_MOCK);

        return this.http
            .post(this.urlService + this.routeAdress.route_recipient, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
    }

    createContact(contactForm: ContactFormData) {
        // Instancia do body através de BaseService.setBody();
        //console.log(`%c CONTACT FORM DATA:`, 'background:salmon;color:#111;');
        //console.log(contactForm);

        let body = this.setBody();

        body.set('subject', contactForm.subject);
        body.set('name', contactForm.name);
        body.set('mail', contactForm.email);
        body.set('text', contactForm.text);
        body.set('notificationId', contactForm.notificationId);

        let response = this.http
            .post(this.urlService + this.routeAdress.route_new_contact, body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));

        return response;
    }

    ticketForRecoveryAccount(recoveryData: AccountRecoveryFormData) {
        let body = this.setBody();

        body.set('name', recoveryData.name);
        body.set('birthDate', recoveryData.birthDate);
        body.set('email', recoveryData.email);
        body.set('document', recoveryData.document);
        body.set('phone', recoveryData.phone);
        body.set('city', recoveryData.city);
        body.set('state', recoveryData.state);

        return this.http
            .post(this.urlService + 'auths/auth/ticketForRecoveryAccount', body.toString())
            .pipe(map(this.extractData), catchError(this.serviceError));
    }
}
interface ContactFormData {
    subject: string;
    name: string;
    email: string;
    text: string;
    notificationId: string;
}

interface AccountRecoveryFormData {
    name: string;
    birthDate: string;
    email: string;
    document: string;
    phone: string;
    city: string;
    state: string;
}
